import './seller-parts-sale-sold-widget.html';
import './seller-parts-sale-sold-widget.scss';
import '../../../partials/parts-sale-listing-status/parts-sale-listing-status.html';
import '../../../partials/parts-sale-listing-dates/parts-sale-listing-dates.html';

import * as angular                         from 'angular';
import { BaseController, IBaseScope }       from '../../../../base-controller';
import { PartsForSaleListingService }       from '../../../../services/odata/parts-for-sale-listing.service';
import { IPartsForSaleListingSearchResult } from 'Row52.Models';

export class SellerPartsSaleSoldWidgetCtrl extends BaseController {
    public static $inject : string[] = [ '$scope', '$window', 'PartsForSaleListingService' ];
    public static SoldPartsForSaleLoaded : string = 'parts-for-sale:loaded';

    constructor(protected $scope : ISellerPartsSaleSoldWidgetScope,
                protected $window : angular.IWindowService,
                private pfsService : PartsForSaleListingService) {
        super();
        this.init();
    }

    protected async init() {
        await super.init();

        await this.loadPartsForSale();
    }

    private async loadPartsForSale() {
        try {
            this.$scope.loading = true;

            let listings              = await this.pfsService.getSoldForSeller(this.$scope.user.id, 5);
            this.$scope.listings      = listings.value;
            this.$scope.listingsCount = listings.count;
            this.$scope.$emit(SellerPartsSaleSoldWidgetCtrl.SoldPartsForSaleLoaded, this.$scope.listingsCount);
        }
        catch (err) {

        }

        this.$scope.loading = false;
    }

    goToPartsSale($event : angular.IAngularEvent, listing : IPartsForSaleListingSearchResult) {
        this.$window.location.href = `/PartsSale/Detail/${listing.id}`;
    }

    goToListings($event : angular.IAngularEvent) {
        $event.preventDefault();

        this.$window.location.href = '/Account/MyListing?tab=1';
    }
}

interface ISellerPartsSaleSoldWidgetScope extends IBaseScope {
    loading : boolean;
    listings : IPartsForSaleListingSearchResult[];
    listingsCount : number;
}

angular.module('Row52.Views.Account.Summary.SellerPartsSaleSoldWidget', [])
       .controller('SellerPartsSaleSoldWidgetCtrl', SellerPartsSaleSoldWidgetCtrl);